import React, { Component } from 'react';
import { Notifier } from '@airbrake/browser';
/* Components */
import { ErrorPage } from '../../pages/ErrorPage';

class AirbrakeErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
    this.airbrake = new Notifier({
      projectId: 319328,
      projectKey: '485ea87d59c9f0a4b7cbdf65a927370c',
    });
    this.airbrake.addFilter((notice) => {
      notice.context.environment = this.detectAirbrakeEnvironment();

      // Ignore errors from Google crawlers
      if (
        notice.context.userAgent &&
        (notice.context.userAgent.includes("AdsBot-Google") ||
          notice.context.userAgent.includes("AdsBot-Google-Mobile") ||
          notice.context.userAgent.includes("Googlebot"))
      ) {
        return null;
      }

      // Ignore errors from Facebook crawlers
      if (
        notice.context.userAgent &&
        notice.context.userAgent.includes("facebookexternalhit")
      ) {
        return null;
      }

      // Ignore errors from Facebook Pixels
      if (
        notice.errors &&
        notice.errors.length &&
        notice.errors[0].message &&
        notice.errors[0].message.includes("fbq")
      ) {
        return null;
      }

      // Ignore errors from Bing crawlers
      if (notice.context.userAgent && notice.context.userAgent.includes("adidxbot")) {
        return null;
      }

      // Ignore errors from TikTok Pixels
      if (
        notice.errors &&
        notice.errors.length &&
        notice.errors[0].backtrace &&
        notice.errors[0].backtrace.length &&
        notice.errors[0].backtrace[0].file &&
        notice.errors[0].backtrace[0].file.includes("analytics.tiktok.com")
      ) {
        return null;
      }

      // Ignore errors caused by disabling javascript
      if (
        notice.errors &&
        notice.errors.length &&
        notice.errors[0].message &&
        (notice.errors[0].message.includes("localStorage") ||
          notice.errors[0].message.includes("sessionStorage") ||
          notice.errors[0].message.includes("getItem") ||
          notice.errors[0].message.includes("removeItem") ||
          notice.errors[0].message.includes("The operation is insecure"))
      ) {
        return null;
      }

      // Inform of errors from /digass/compass-assistant/
      if (
        notice.errors &&
        notice.errors.length &&
        notice.errors[0].backtrace &&
        notice.errors[0].backtrace.length &&
        notice.errors[0].backtrace[0].file &&
        notice.errors[0].backtrace[0].file.includes("digass/compass-assistant/")
      ) {
        notice.context.severity = "info";
      }

      // Ignore errors from development.
      if (
        notice.context.environment &&
        notice.context.environment === 'development'
      ) {
        return null;
      }

      return notice;
    });

    this.detectAirbrakeEnvironment = this.detectAirbrakeEnvironment.bind(this);
  }

  componentDidCatch(error, info) {
    // Display fallback UI
    this.setState({ hasError: true });

    // Send error to Airbrake
    this.airbrake.notify({
      error: error,
      params: {info: info}
    });
  }

  detectAirbrakeEnvironment() {
    switch (window.location.hostname) {
      case 'localhost':
        return 'development';
      case 'cmpcol.appcenter.it':
      case 'compass-col.int.compassonline.it':
        return 'staging';
      case 'www.compass.it':
        return 'production';
      default:
        return 'not specified';
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <ErrorPage />
      );
    }
    return this.props.children;
  }
}

export default AirbrakeErrorBoundary;
